var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "card search-card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "col-sm-3 col-md-2" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "search-workplace-name" } }, [
                _vm._v("工作地點"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.search.keyword,
                    expression: "search.keyword",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "search-workplace-name",
                  placeholder: "請輸入關鍵字",
                },
                domProps: { value: _vm.search.keyword },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.getWorkplace.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.search, "keyword", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "col-sm-3 col-md-4" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                staticStyle: { "margin-top": "30px", "margin-left": "10px" },
                attrs: { type: "button" },
                on: { click: _vm.getWorkplace },
              },
              [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Search")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                staticStyle: { "margin-top": "30px", "margin-left": "10px" },
                attrs: {
                  type: "button",
                  "data-toggle": "modal",
                  "data-target": "#workplaceModal",
                },
                on: {
                  click: function ($event) {
                    return _vm.workplaceModal({ action: "add" })
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Add")) + " ")]
            ),
          ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "yahome-table-wrap" },
      [
        _c(
          "VueBootstrap4Table",
          {
            attrs: {
              rows: _vm.rows,
              columns: _vm.columns,
              config: _vm.config,
              "total-rows": _vm.totalData,
            },
            on: { "on-change-query": _vm.changePage },
            scopedSlots: _vm._u([
              {
                key: "Edit",
                fn: function (props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info btn-sm",
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#workplaceModal",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.workplaceModal({
                              action: "edit",
                              data: props.row,
                            })
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Edit")) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "Delete",
                fn: function (props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger btn-sm",
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#delWorkPlaceModal",
                        },
                        on: {
                          click: function ($event) {
                            _vm.workplace = { ...props.row }
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
                    ),
                  ]
                },
              },
            ]),
          },
          [_c("template", { slot: "empty-results" }, [_vm._v(" 暫無資料 ")])],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "workplaceModal",
          tabindex: "-1",
          "data-backdrop": "static",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered" },
          [
            _c("ValidationObserver", {
              ref: "workplace",
              staticClass: "modal-content",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, reset }) {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            reset: function ($event) {
                              $event.preventDefault()
                              return reset.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "modal-header" }, [
                            _vm.action === "add"
                              ? _c("span", [_vm._v("新增工作地點")])
                              : _c("span", [_vm._v("編輯工作地點")]),
                          ]),
                          _c("div", { staticClass: "modal-body" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("ValidationProvider", {
                                  attrs: {
                                    name: "工作地點",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for: "modal-workplace-name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _vm._v(" 工作地點 "),
                                              ]
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.trim",
                                                  value:
                                                    _vm.workplace.WorkPlaceName,
                                                  expression:
                                                    "workplace.WorkPlaceName",
                                                  modifiers: { trim: true },
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                id: "modal-workplace-name",
                                                maxlength: "50",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.workplace.WorkPlaceName,
                                              },
                                              on: {
                                                compositionstart: function (
                                                  $event
                                                ) {
                                                  _vm.is_composing = true
                                                },
                                                compositionend: function (
                                                  $event
                                                ) {
                                                  _vm.is_composing = false
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.workplace,
                                                    "WorkPlaceName",
                                                    $event.target.value.trim()
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            errors[0] && !_vm.is_composing
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "reset",
                                  "data-dismiss": "modal",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Buttons.Cancel")) + " "
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.saveWorkplace)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Buttons.Save")) + " "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "delWorkPlaceModal",
          tabindex: "-1",
          "data-backdrop": "static",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm._v("刪除工作地點"),
            ]),
            _c("div", { staticClass: "modal-body" }, [
              _vm._v(" 確認刪除 "),
              _c(
                "span",
                { staticStyle: { "font-weight": "bolder", color: "red" } },
                [_vm._v(" " + _vm._s(_vm.workplace.WorkPlaceName) + " ")]
              ),
              _vm._v(" ? "),
            ]),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "reset", "data-dismiss": "modal" },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Cancel")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: { click: _vm.delWorkplace },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }